import { render, staticRenderFns } from "./parent-request-info.vue?vue&type=template&id=a55e312e&scoped=true&"
import script from "./parent-request-info.vue?vue&type=script&lang=js&"
export * from "./parent-request-info.vue?vue&type=script&lang=js&"
import style0 from "./parent-request-info.vue?vue&type=style&index=0&id=a55e312e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55e312e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
